module.exports = __webpack_public_path__ + "img/area-1.8bbcf10.png";